// 集中管理引导进行新版KYC的路径，避免多个站点下不一样导致调整太多
export var kycV2GuideRoute = "/account/kyc/level1";